import styled, { css } from 'styled-components';
import { PortalTooltipSide, PortalTooltipAlignment } from './PortalTooltip.types';

const ARROW_COLOR = '#1d2939';
const ARROW_EDGE_OFFSET = '12px';

const getHorizontalArrowAlignment = (alignment: PortalTooltipAlignment) => {
  switch (alignment) {
    case 'start':
      return css`
        left: ${ARROW_EDGE_OFFSET};
        transform: none;
      `;
    case 'end':
      return css`
        left: auto;
        right: ${ARROW_EDGE_OFFSET};
        transform: none;
      `;
    case 'center':
    default:
      return css`
        left: var(--tooltip-arrow-left, 50%);
        transform: translateX(-50%);
      `;
  }
};

const getVerticalArrowAlignment = (alignment: PortalTooltipAlignment) => {
  switch (alignment) {
    case 'start':
      return css`
        top: ${ARROW_EDGE_OFFSET};
        transform: none;
      `;
    case 'end':
      return css`
        top: auto;
        bottom: ${ARROW_EDGE_OFFSET};
        transform: none;
      `;
    case 'center':
    default:
      return css`
        top: var(--tooltip-arrow-top, 50%);
        transform: translateY(-50%);
      `;
  }
};

const getArrowCss = (side: PortalTooltipSide, alignment: PortalTooltipAlignment) => {
  switch (side) {
    case 'bottom':
      return css`
        bottom: 100%;
        border-color: transparent transparent ${ARROW_COLOR} transparent;
        ${getHorizontalArrowAlignment(alignment)}
      `;
    case 'left':
      return css`
        left: 100%;
        border-color: transparent transparent transparent ${ARROW_COLOR};
        ${getVerticalArrowAlignment(alignment)}
      `;
    case 'right':
      return css`
        right: 100%;
        border-color: transparent ${ARROW_COLOR} transparent transparent;
        ${getVerticalArrowAlignment(alignment)}
      `;
    case 'top':
    default:
      return css`
        top: 100%;
        border-color: ${ARROW_COLOR} transparent transparent transparent;
        ${getHorizontalArrowAlignment(alignment)}
      `;
  }
};

interface StyledPortalTooltipProps {
  $side: PortalTooltipSide;
  $alignment: PortalTooltipAlignment;
  $simple: boolean;
}

export const StyledPortalTooltip = styled.div<StyledPortalTooltipProps>`
  position: fixed;
  top: 0;
  left: 0;
  visibility: hidden;
  background-color: ${ARROW_COLOR};
  color: white;
  border-radius: 12px;
  padding: 8px 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  pointer-events: none;

  ${({ $simple }) =>
    $simple
      ? css`
          font-size: 14px;
          font-weight: 600;
          line-height: 20px;
          white-space: nowrap;
        `
      : css`
          white-space: normal;
          max-width: 320px;
        `}

  &::after {
    content: '';
    position: absolute;
    border-width: 5px;
    border-style: solid;
    ${({ $side, $alignment }) => getArrowCss($side, $alignment)}
  }
`;
